import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';

import { fetchSituationsCategory, fetchedSituationsCategory } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

export function* getSituationsCategorySaga() {
  const { getSituationsCategory } = getAPI();
  const response: YieldOf<typeof getSituationsCategory> = yield call(getSituationsCategory);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedSituationsCategory(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedSituationsCategory(undefined, error));
  }
}

export default function* situationCategorySaga() {
  yield takeLatest(fetchSituationsCategory.type, getSituationsCategorySaga);
}
